import Modal from 'react-modal';
import SupportPhoneNumber from '../SupportPhoneNumber';
import styles from './styles';

interface VirtualDirectoryInfoModalProps {
  closeModal: () => void;
  isOpen: boolean;
  supportPhoneNumber?: string | null;
  leasingOfficeDisplayName: string;
}

Modal.setAppElement('#root');

export const VirtualDirectoryInfoModal = (props: VirtualDirectoryInfoModalProps) => {
  const { closeModal, isOpen, supportPhoneNumber, leasingOfficeDisplayName } = props;

  return (
    <Modal
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={closeModal}
      isOpen={isOpen}
    >
      <div className={styles.modal}>
        <div className={styles.modalText}>
          <h1 className={styles.title}>Directory Help</h1>
          <div className={styles.text}>
            <ol className={styles.orderList}>
              <li className={styles.spacer}>
                <b>Look up the person you want to contact</b> using their name or unit number.
              </li>
              <li className={styles.spacer}>
                <b>Tap the Call button</b> to request access through a phone call.
              </li>
              <li className={styles.spacer}>
                <b>Listen to the phone prompts</b> to know when your access is approved!
              </li>
            </ol>
          </div>
          <div className={styles.text}>
            <SupportPhoneNumber
              supportPhoneNumber={supportPhoneNumber}
              leasingOfficeDisplayName={leasingOfficeDisplayName}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default VirtualDirectoryInfoModal;
